import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

const BOOK_COVER_URL = 'https://customer-assets.emergentagent.com/job_30b1d3cb-b799-4691-ba56-7e824b5598c4/artifacts/p185kuox_font%20cover%20jpg.jpg';

const BOOKS = [
  {
    id: 'cultural-fluency-without-compromise',
    title: 'CULTURAL FLUENCY',
    titleLine2: 'WITHOUT COMPROMISE',
    subtitle: 'Thriving Across Cultures with Presence and Integrity',
    author: 'PROMISE MONDAY',
    coverImage: BOOK_COVER_URL,
    price: '£9.99',
    href: '/books/cultural-fluency-without-compromise',
    available: true
  }
];

const BooksHubPage = () => {
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      {/* Header */}
      <header className="bg-[#2c3e50] text-white py-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <BookOpen className="w-12 h-12 mx-auto mb-4 text-[#d4af37]" />
          <h1 className="text-4xl md:text-5xl font-bold font-display mb-4">Books</h1>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            Leadership insights for navigating cultural complexity with authenticity and impact.
          </p>
        </div>
      </header>

      {/* Books Grid */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {BOOKS.map((book) => (
              <Link
                key={book.id}
                to={book.href}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                data-testid={`book-card-${book.id}`}
              >
                {/* Book Cover - Use actual image if available */}
                <div className="aspect-[3/4] bg-gradient-to-br from-[#2c3e50] to-[#1a252f] overflow-hidden">
                  {book.coverImage && book.available ? (
                    <img 
                      src={book.coverImage}
                      alt={`${book.title} ${book.titleLine2} cover`}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full p-8 flex items-center justify-center">
                      <div className="text-center text-white">
                        <p className="text-xs tracking-[0.3em] text-[#d4af37] mb-4">COMING SOON</p>
                        <h2 className="text-2xl font-bold tracking-wide mb-1">{book.title}</h2>
                        <h2 className="text-2xl font-bold tracking-wide mb-4">{book.titleLine2}</h2>
                        <div className="w-16 h-0.5 bg-[#d4af37] mx-auto mb-4" />
                        <p className="text-sm text-white/80 mb-6 px-4">{book.subtitle}</p>
                        <p className="text-sm tracking-[0.2em] text-[#d4af37]">{book.author}</p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Card Footer */}
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-[#5a6c7d]">eBook</p>
                      <p className="text-xl font-bold text-[#2c3e50]">{book.price}</p>
                    </div>
                    <div className="flex items-center gap-2 text-[#d4af37] group-hover:translate-x-1 transition-transform">
                      <span className="text-sm font-medium">View Book</span>
                      <ArrowRight size={18} />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Coming Soon Placeholder */}
      <section className="py-16 px-4 bg-white/50">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-[#5a6c7d] mb-2">More books coming soon</p>
          <p className="text-sm text-[#5a6c7d]/70">
            Sign up for our newsletter to be notified when new titles are released.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#2c3e50] text-white py-8">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-sm text-white/60">
            © {new Date().getFullYear()} Third Culture Leadership. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default BooksHubPage;
